import { useState, useEffect } from "react";
import Input from "../../../../../utils/components/Input";
import Button from "../../../../../utils/components/Button";
import Modal from "../../../../../utils/components/Modal";
import Editor from "@monaco-editor/react";

const editorOptions = {
  minimap: {
    enabled: false,
  },
  fontSize: 14,
  lineHeight: 1.5,
  wordWrap: "on",
  wordWrapMinified: true,
  quickSuggestions: false,
};

const StepInfo = ({ step, handleAction, translate }) => {
  const [showEditorFullScreen, setShowEditorFullScreen] = useState(false);
  const [code, setCode] = useState(step.settings.step_info.code || "");
  const [textTitle, setTextTitle] = useState(
    step.settings.step_info.info_title || ""
  );
  const [textContent, setTextContent] = useState(
    step.settings.step_info.info_description || ""
  );

  useEffect(() => {
    handleAction("step_info", {
      textTitle,
      textContent,
      code,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, textTitle, textContent]);

  return (
    <div>
      <div className="row d-flex align-items-center mt-3">
        <div className="col-11">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate("design_approval_process.step-edit-modal.step-title")}
          </p>
          <Input
            type="text"
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.step-title"
            )}
            onChange={(e) => setTextTitle(e.target.value)}
            value={textTitle}
          />
        </div>
      </div>
      <div className="row d-flex align-items-center mt-3">
        <div className="col-11">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate("design_approval_process.step-edit-modal.step-content")}
          </p>
          <Input
            placeholder={translate(
              "design_approval_process.step-edit-modal.placeholders.step-content"
            )}
            onChange={(e) => setTextContent(e.target.value)}
            value={textContent}
          />
        </div>
      </div>
      <div className="row d-flex align-items-center mt-3">
        <div className="code-editor col-11 border border-2 rounded">
          <div className="text-end my-1">
            <Button
              type="button"
              className="btn-secondary"
              onClick={() => setShowEditorFullScreen(true)}
            >
              Genişlet
            </Button>
          </div>
          <Editor
            height="30vh"
            defaultLanguage=""
            defaultValue={code}
            value={code}
            onChange={(value) => setCode(value)}
            options={editorOptions}
          />
        </div>
      </div>
      <Modal
        modalSize="xl"
        title="Editor"
        show={showEditorFullScreen}
        setShow={setShowEditorFullScreen}
      >
        <Editor
          height="80vh"
          width="100%"
          defaultLanguage=""
          defaultValue={code}
          value={code}
          onChange={(value) => setCode(value)}
          options={editorOptions}
        />
      </Modal>
    </div>
  );
};
export default StepInfo;
